export const ASSET_POLLING_INTERVAL = 1000;
export const SMALL_ICONS_PER_ROW = 16;
export const LARGE_ICONS_PER_ROW = 8;
export const SEARCH_RESULTS_HITS_PER_PAGE = 1000;
export const TYPEFACE_PREVIEW_SPECIMEN = 'When my six o’clock alarm buzzes, I require a pot of good java.';
export const TYPEFACE_WEIGHTS = [
  'normal',
  'bold',
  '100',
  '200',
  '300',
  '400',
  '500',
  '600',
  '700',
  '800',
  '900',
];
export const TYPEFACE_STYLES = [
  'normal',
  'italic',
  'oblique',
];



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/settings.js